import { DandelionSeed } from "@/components/DandelionSeed";

/* ============================== Impressum ============================== */
export function Impressum() {
  return (
    <section
      id="impressum"
      data-testid="impressum-section"
      className="py-20 lg:py-28 border-t"
      style={{ borderColor: "var(--line)" }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="eyebrow reveal">Rechtliches</p>
        <h2
          className="font-display text-4xl sm:text-5xl mt-4 reveal reveal-delay-1"
          style={{ color: "var(--ink)" }}
        >
          Impressum
        </h2>

        {/* Angaben Diensteanbieter */}
        <Block title="Angaben gemäß § 5 TMG / § 18 Abs. 2 MStV" delay={2}>
          <p style={{ color: "var(--ink)" }}>Petra Fellmann</p>
          <p>Heilpraktikerin für Psychotherapie</p>
          <p>Praxis Seelen-Raum</p>
          <p className="mt-3">Eckernförderstraße 22 b</p>
          <p>24361 Haby</p>
          <p>Deutschland</p>
        </Block>

        <Block title="Kontakt" delay={2}>
          <p>Telefon: <a href="tel:+4915174408748" className="soft-link">+49 151 74408748</a></p>
          <p>
            E-Mail:{" "}
            <a href="mailto:trauma-fellmann@web.de" className="soft-link">
              trauma-fellmann@web.de
            </a>
          </p>
          <p>Web: trauma-fellmann.de</p>
        </Block>

        <Block title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV" delay={3}>
          <p>Petra Fellmann (Anschrift wie oben)</p>
        </Block>

        <Block title="Berufsbezeichnung & berufsrechtliche Angaben" delay={3}>
          <p>
            <strong style={{ color: "var(--ink)" }}>Gesetzliche Berufsbezeichnung:</strong>{" "}
            Heilpraktikerin beschränkt auf das Gebiet der Psychotherapie
            (verliehen in der Bundesrepublik Deutschland).
          </p>
          <p className="mt-2">
            Die Erlaubnis nach § 1 Abs. 1 des Heilpraktikergesetzes wurde mir am 07.12.2023
            durch das Gesundheitsamt des Kreises Rendsburg-Eckernförde erteilt.
          </p>
          <p className="mt-4">
            <strong style={{ color: "var(--ink)" }}>Zuständige Aufsichtsbehörde:</strong>
          </p>
          <p>Kreis Rendsburg-Eckernförde</p>
          <p>Kaiserstraße 8, 24768 Rendsburg</p>
          <p>
            <a
              href="https://www.kreis-rendsburg-eckernfoerde.de/gesundheit-pflege"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              kreis-rendsburg-eckernfoerde.de/gesundheit-pflege
            </a>
          </p>
        </Block>

        <Block title="Berufsrechtliche Regelungen" delay={4}>
          <p>Heilpraktikergesetz und Durchführungsverordnung:</p>
          <p>
            <a
              href="https://www.gesetze-im-internet.de/heilprg/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              gesetze-im-internet.de/heilprg
            </a>
            {" · "}
            <a
              href="https://www.gesetze-im-internet.de/heilprgdv_1/index.html"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              gesetze-im-internet.de/heilprgdv_1
            </a>
          </p>
          <p className="mt-4">
            <strong style={{ color: "var(--ink)" }}>Verbandsmitgliedschaft:</strong>{" "}
            Mitglied im Verband Freier Psychotherapeuten, Heilpraktiker für Psychotherapie
            und Psychologischer Berater e. V. (VFP) —{" "}
            <a
              href="https://vfp.de/verband/berufsordnung"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              Berufsordnung des VFP
            </a>
          </p>
          <p className="mt-4">
            <strong style={{ color: "var(--ink)" }}>Berufshaftpflichtversicherung:</strong>{" "}
            Geltungsbereich: Bundesrepublik Deutschland.
          </p>
        </Block>

        <Block title="Umsatzsteuer" delay={4}>
          <p>
            Hinweis auf § 4 Nr. 14 UStG: Heilkundliche Tätigkeiten sind gemäß § 4 Nr. 14 UStG
            von der Umsatzsteuer befreit. Aus diesem Grund erhebe ich keine Umsatzsteuer und
            weise diese folglich auch nicht aus.
          </p>
        </Block>

        <Block title="Technische Umsetzung & Hosting" delay={4}>
          <p>
            Diese Website wird über die Plattform <strong style={{ color: "var(--ink)" }}>Emergent</strong>{" "}
            (Emergent Labs) bereitgestellt und gehostet. Anbieter:
          </p>
          <p>Emergent Labs · emergent.sh</p>
          <p>Erreichbar unter:{" "}
            <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="soft-link">
              emergent.sh
            </a>
          </p>
          <p className="mt-3">
            Beim Aufruf der Website werden technische Verbindungsdaten (siehe Datenschutzerklärung)
            durch den Hosting-Dienstleister verarbeitet.
          </p>
        </Block>

        <Block title="Bildnachweise" delay={5}>
          <p>
            Das auf dieser Website verwendete Hintergrundbild wurde auf Grundlage eines mit
            künstlicher Intelligenz erzeugten Bildes erstellt und anschließend individuell
            bearbeitet sowie an das Design der Website angepasst. Die Bildgestaltung erfolgte
            eigenständig für die Nutzung auf dieser Website.
          </p>
        </Block>

        <Block title="Streitschlichtung" delay={5}>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              ec.europa.eu/consumers/odr
            </a>
            . Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Block>

        <Block title="Haftungshinweis" delay={5}>
          <p>
            Nicht alle der auf dieser Webseite beschriebenen psychotherapeutischen Verfahren gelten in
            Deutschland als „wissenschaftlich anerkannt" nach den Kriterien der Schulmedizin, werden
            aber hier und in vielen anderen Ländern der Welt auf der Basis von Erfahrungswissen
            angewandt. Welche Ansätze für Sie geeignet erscheinen, finden wir gemeinsam heraus, wobei
            ein Heil- oder Erfolgsversprechen nicht gegeben werden kann — zumal Ablauf und Wirkung
            einer konkreten Behandlung stets von vielen individuellen Faktoren abhängen.
          </p>
          <p className="mt-3">
            Für die Inhalte externer Links wird trotz sorgfältiger Prüfung keine Haftung übernommen;
            für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          </p>
        </Block>

        <p className="mt-10 text-xs" style={{ color: "var(--ink-mute)" }}>
          Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
        </p>
      </div>
    </section>
  );
}

/* ============================ Datenschutz ============================== */
export function Datenschutz({ onOpenCookieSettings }) {
  return (
    <section
      id="datenschutz"
      data-testid="datenschutz-section"
      className="py-20 lg:py-28 border-t"
      style={{ borderColor: "var(--line)" }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <p className="eyebrow reveal">Datenschutz</p>
        <h2
          className="font-display text-4xl sm:text-5xl mt-4 reveal reveal-delay-1"
          style={{ color: "var(--ink)" }}
        >
          Datenschutzerklärung
        </h2>

        <p
          className="mt-8 text-[15px] leading-relaxed reveal reveal-delay-2"
          style={{ color: "var(--ink-soft)" }}
        >
          Im Folgenden informieren wir Sie über die Erhebung personenbezogener Daten bei der
          Nutzung dieser Website. Personenbezogene Daten sind alle Daten, die auf Sie persönlich
          beziehbar sind, z. B. Name, Adresse, E-Mail-Adresse oder Nutzerverhalten.
        </p>

        <Block title="1. Verantwortlicher" delay={2}>
          <p>Verantwortlich i.S.d. Art. 4 Nr. 7 DSGVO ist:</p>
          <p className="mt-2" style={{ color: "var(--ink)" }}>
            Petra Fellmann · Praxis Seelen-Raum
          </p>
          <p>Heilpraktikerin beschränkt auf das Gebiet der Psychotherapie</p>
          <p>Eckernförderstraße 22 b, 24361 Haby</p>
          <p>
            Telefon: <a href="tel:+4915174408748" className="soft-link">+49 151 74408748</a>
            {" · "}
            E-Mail: <a href="mailto:trauma-fellmann@web.de" className="soft-link">trauma-fellmann@web.de</a>
          </p>
        </Block>

        <Block title="2. Zuständige Datenschutzaufsichtsbehörde" delay={2}>
          <p>Unabhängiges Landeszentrum für Datenschutz Schleswig-Holstein (ULD)</p>
          <p>Holstenstraße 98, 24103 Kiel — Postfach 71 16, 24171 Kiel</p>
          <p>
            Telefon: 0431/988-1200 · E-Mail:{" "}
            <a href="mailto:mail@datenschutzzentrum.de" className="soft-link">
              mail@datenschutzzentrum.de
            </a>
          </p>
          <p>
            <a
              href="https://www.datenschutzzentrum.de"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              datenschutzzentrum.de
            </a>
          </p>
        </Block>

        <Block title="3. Erhebung beim Besuch der Website (Server-Logfiles)" delay={3}>
          <p>
            Beim Aufrufen unserer Website trauma-fellmann.de werden durch den von Ihrem Endgerät
            verwendeten Browser automatisch Informationen an den Server unseres Hosting-Anbieters
            <strong style={{ color: "var(--ink)" }}> Emergent (emergent.sh) </strong>
            gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert.
            Erfasst werden:
          </p>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li>IP-Adresse des anfragenden Rechners (gekürzt / anonymisiert, soweit möglich)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Referrer-URL (Website, von der aus der Zugriff erfolgt)</li>
            <li>verwendeter Browser, ggf. Betriebssystem und Name des Access-Providers</li>
          </ul>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Zwecke:</strong> Gewährleistung eines reibungslosen
            Verbindungsaufbaus, komfortable Nutzung der Website, Auswertung der Systemsicherheit
            und -stabilität sowie weitere administrative Zwecke.
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f
            DSGVO (berechtigtes Interesse an einem sicheren, stabilen Betrieb). Die Daten werden
            grundsätzlich nach kurzer Zeit gelöscht und nicht mit Ihrer Person zusammengeführt.
          </p>
        </Block>

        <Block title="4. Kontaktaufnahme & Kontaktformular" delay={3}>
          <p>
            Bei der Kontaktaufnahme über das Kontaktformular auf dieser Website oder per E-Mail
            an{" "}
            <a href="mailto:trauma-fellmann@web.de" className="soft-link">
              trauma-fellmann@web.de
            </a>{" "}
            werden die von Ihnen mitgeteilten Daten (Name, E-Mail-Adresse, Nachricht) bei mir
            gespeichert, um Ihre Anfrage zu beantworten.
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b
            DSGVO (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
            Interesse an der Bearbeitung der Anfrage).
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Auftragsverarbeiter für den E-Mail-Versand:</strong>{" "}
            Für den technischen Versand der Formularnachrichten setze ich den Dienst{" "}
            <strong style={{ color: "var(--ink)" }}>Resend</strong> (Resend, Inc., USA) ein.
            Mit Resend besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO.
            Datenübermittlungen in Drittländer erfolgen auf Grundlage von
            Standardvertragsklauseln (Art. 46 DSGVO) bzw. der Angemessenheitsentscheidung
            (EU-US Data Privacy Framework).
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Speicherdauer:</strong> Wir löschen die in
            diesem Zusammenhang anfallenden Daten, nachdem die Speicherung nicht mehr erforderlich
            ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungsfristen
            bestehen.
          </p>
        </Block>

        <Block title="5. Weitergabe von Daten" delay={4}>
          <p>
            Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden
            aufgeführten Zwecken erfolgt nicht. Wir geben Ihre Daten nur an Dritte weiter, wenn:
          </p>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li>Sie nach Art. 6 Abs. 1 lit. a DSGVO ausdrücklich eingewilligt haben,</li>
            <li>die Weitergabe nach Art. 6 Abs. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist und kein überwiegendes schutzwürdiges Interesse Ihrerseits entgegensteht,</li>
            <li>eine gesetzliche Verpflichtung nach Art. 6 Abs. 1 lit. c DSGVO besteht, sowie</li>
            <li>dies nach Art. 6 Abs. 1 lit. b DSGVO für die Abwicklung von Vertragsverhältnissen erforderlich ist.</li>
          </ul>
        </Block>

        <Block title="6. Cookies & lokale Speicherung" delay={4}>
          <p>
            Diese Website setzt <strong style={{ color: "var(--ink)" }}>ausschließlich technisch
            notwendige Cookies</strong> bzw. einen Eintrag im lokalen Speicher des Browsers
            (localStorage) ein, um Ihre Cookie-Auswahl zu merken. Es werden{" "}
            <strong style={{ color: "var(--ink)" }}>keine</strong> Tracking-, Analyse- oder
            Marketing-Cookies (z. B. Google Analytics) verwendet.
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Rechtsgrundlage:</strong> § 25 Abs. 2 Nr. 2 TTDSG
            (technisch notwendige Speicherung) sowie Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <div className="mt-4">
            <button
              data-testid="datenschutz-cookie-settings"
              onClick={onOpenCookieSettings}
              className="btn-secondary !py-2.5 !px-4 !text-sm"
            >
              <DandelionSeed size={16} />
              Cookie-Einstellungen öffnen
            </button>
          </div>
        </Block>

        <Block title="7. Eingebundene Schriften (Google Fonts)" delay={5}>
          <p>
            Diese Website verwendet die Schriftarten „Cormorant Garamond" und „Manrope", die über{" "}
            <strong style={{ color: "var(--ink)" }}>Google Fonts</strong> (Google Ireland Limited,
            Dublin, Irland) eingebunden sind. Beim Aufruf wird kurzzeitig eine Verbindung zu
            Servern von Google hergestellt, wodurch Ihre IP-Adresse übermittelt werden kann.
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f
            DSGVO (berechtigtes Interesse an einer einheitlichen, lesbaren Darstellung). Auf Wunsch
            kann das Hosting der Schriften vollständig auf den eigenen Server umgestellt werden
            (lokales Hosting), um eine Drittlandübermittlung zu vermeiden.
          </p>
        </Block>

        <Block title="8. Google Maps" delay={5}>
          <p>
            Im Bereich „Anfahrt" auf der Kontaktseite ist eine Karte von{" "}
            <strong style={{ color: "var(--ink)" }}>Google Maps</strong> (Google Ireland Limited,
            Gordon House, Barrow Street, Dublin 4, Irland) eingebunden, um Ihnen den Standort der
            Praxis komfortabel anzuzeigen. Beim Aufrufen der Seite wird die Karte vom Server von
            Google geladen; dabei werden technische Daten (insb. IP-Adresse, Browserinformationen)
            an Google übertragen.
          </p>
          <p className="mt-3">
            <strong style={{ color: "var(--ink)" }}>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f
            DSGVO (berechtigtes Interesse an einer barrierearmen Darstellung des Praxisstandorts).
            Wenn Sie bei Google eingeloggt sind, können Ihre Daten Ihrem Konto zugeordnet werden;
            ggf. müssen Sie sich vorher ausloggen. Weitere Informationen:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="soft-link"
            >
              policies.google.com/privacy
            </a>
            .
          </p>
        </Block>

        <Block title="9. Betroffenenrechte" delay={5}>
          <p>Sie haben — soweit das Patientenrechtegesetz keine vorrangigen Verpflichtungen bestimmt — das Recht:</p>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li>auf Auskunft (Art. 15 DSGVO),</li>
            <li>auf Berichtigung (Art. 16 DSGVO),</li>
            <li>auf Löschung (Art. 17 DSGVO),</li>
            <li>auf Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
            <li>auf Datenübertragbarkeit (Art. 20 DSGVO),</li>
            <li>Ihre Einwilligung jederzeit zu widerrufen (Art. 7 Abs. 3 DSGVO),</li>
            <li>Beschwerde bei einer Aufsichtsbehörde einzulegen (Art. 77 DSGVO).</li>
          </ul>
        </Block>

        <Block title="10. Widerspruchsrecht" delay={5}>
          <p>
            Soweit Ihre personenbezogenen Daten auf Grundlage berechtigter Interessen gemäß Art. 6
            Abs. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO
            Widerspruch gegen die Verarbeitung einzulegen, soweit dafür Gründe vorliegen, die sich
            aus Ihrer besonderen Situation ergeben. Eine kurze E-Mail an{" "}
            <a href="mailto:trauma-fellmann@web.de" className="soft-link">
              trauma-fellmann@web.de
            </a>{" "}
            genügt.
          </p>
        </Block>

        <Block title="11. Datensicherheit" delay={5}>
          <p>
            Wir bedienen uns geeigneter technischer und organisatorischer Sicherheitsmaßnahmen,
            um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder
            vollständigen Verlust, Zerstörung oder unbefugten Zugriff Dritter zu schützen
            (insb. TLS-Verschlüsselung der Verbindung).
          </p>
        </Block>

        <Block title="12. Aktualität & Änderungen" delay={5}>
          <p>
            Diese Datenschutzerklärung ist aktuell gültig. Sofern gesetzliche Änderungen oder
            Änderungen am Funktionsumfang der Website dies erforderlich machen, wird sie
            entsprechend aktualisiert. Stand:{" "}
            {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </p>
        </Block>

        {/* Cookie anchor — opens modal */}
        <div id="cookies" className="mt-12 reveal reveal-delay-3">
          <h3 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>
            Cookie-Richtlinie
          </h3>
          <p
            className="mt-3 text-[15px] leading-relaxed max-w-2xl"
            style={{ color: "var(--ink-soft)" }}
          >
            Diese Website verwendet ausschließlich technisch notwendige Cookies bzw. eine
            funktional notwendige lokale Speicherung. Sie können Ihre Auswahl jederzeit anpassen.
          </p>
          <button
            data-testid="open-cookie-settings"
            onClick={onOpenCookieSettings}
            className="btn-secondary mt-6"
          >
            <DandelionSeed size={16} />
            Cookie-Einstellungen öffnen
          </button>
        </div>
      </div>
    </section>
  );
}

/* ----------------------------- Helper ------------------------------- */
const Block = ({ title, children, delay = 1 }) => (
  <div className={`mt-10 reveal reveal-delay-${Math.min(delay, 5)}`}>
    <h3
      className="font-serif text-xl sm:text-2xl"
      style={{ color: "var(--ink)" }}
    >
      {title}
    </h3>
    <div
      className="mt-3 space-y-1.5 text-[15px] leading-relaxed"
      style={{ color: "var(--ink-soft)" }}
    >
      {children}
    </div>
  </div>
);
